import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

function Terms() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-content">
          <h1 onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>EduStaff</h1>
          <button className="btn-back" onClick={() => navigate(-1)}>
            ← 뒤로가기
          </button>
        </div>
      </header>

      <main className="legal-content">
        <div className="legal-container">
          <h1 className="legal-title">이용약관</h1>
          <p className="legal-updated">최종 업데이트: 2024년 12월 24일</p>

          <section className="legal-section">
            <h2>제1조 (목적)</h2>
            <p>
              본 약관은 아이지에듀랩(이하 "회사")이 제공하는 EduStaff 서비스(이하 "서비스")의 이용과 관련하여
              회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>제2조 (정의)</h2>
            <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다:</p>
            <ol>
              <li>"서비스"라 함은 회사가 제공하는 학원 관리 시스템 및 관련 부가서비스를 의미합니다.</li>
              <li>"이용자"라 함은 본 약관에 따라 회사가 제공하는 서비스를 이용하는 회원 및 비회원을 말합니다.</li>
              <li>"회원"이라 함은 회사와 서비스 이용계약을 체결하고 아이디를 부여받은 자를 말합니다.</li>
              <li>"아이디(ID)"라 함은 회원의 식별과 서비스 이용을 위하여 회원이 설정하고 회사가 승인하는 문자와 숫자의 조합을 의미합니다.</li>
              <li>"비밀번호"라 함은 회원의 정보보호를 위해 회원 자신이 설정한 문자와 숫자의 조합을 의미합니다.</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제3조 (약관의 게시와 개정)</h2>
            <ol>
              <li>회사는 본 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.</li>
              <li>회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
              <li>회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 서비스 초기 화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.</li>
              <li>회원은 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 이용계약을 해지할 수 있습니다.</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제4조 (서비스의 제공 및 변경)</h2>
            <ol>
              <li>회사는 다음과 같은 서비스를 제공합니다:
                <ul>
                  <li>학생 정보 관리</li>
                  <li>출결 관리</li>
                  <li>수업 관리</li>
                  <li>성적 관리</li>
                  <li>수강료 관리</li>
                  <li>학부모 소통 기능</li>
                  <li>기타 회사가 추가 개발하거나 제휴계약 등을 통해 회원에게 제공하는 일체의 서비스</li>
                </ul>
              </li>
              <li>회사는 서비스의 내용을 변경할 경우에는 변경사항을 서비스 화면에 공지합니다.</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제5조 (서비스 이용계약의 성립)</h2>
            <ol>
              <li>이용계약은 이용자가 본 약관에 동의하고 회사가 정한 절차에 따라 회원가입을 신청하여 회사가 이를 승낙함으로써 체결됩니다.</li>
              <li>회사는 다음 각 호에 해당하는 경우 승낙을 거부하거나 보류할 수 있습니다:
                <ul>
                  <li>실명이 아니거나 타인의 명의를 사용한 경우</li>
                  <li>허위의 정보를 기재하거나 회사가 요구하는 내용을 기재하지 않은 경우</li>
                  <li>부정한 용도로 서비스를 이용하고자 하는 경우</li>
                  <li>기타 회사가 정한 이용신청 요건이 미비한 경우</li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제6조 (회원 정보의 변경)</h2>
            <ol>
              <li>회원은 서비스 이용 신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 이메일 등의 방법으로 회사에 그 변경사항을 알려야 합니다.</li>
              <li>회원정보를 변경하지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제7조 (회원 탈퇴 및 자격 상실)</h2>
            <ol>
              <li>회원은 언제든지 서비스 이용을 원하지 않는 경우 회원 탈퇴를 요청할 수 있으며, 회사는 즉시 회원탈퇴를 처리합니다.</li>
              <li>회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 정지시킬 수 있습니다:
                <ul>
                  <li>가입 신청 시 허위 내용을 등록한 경우</li>
                  <li>다른 사람의 서비스 이용을 방해하거나 정보를 도용하는 등 전자거래질서를 위협하는 경우</li>
                  <li>서비스를 이용하여 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제8조 (요금 및 유료서비스)</h2>
            <ol>
              <li>회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 특정 부가서비스 이용 시 요금이 부과될 수 있습니다.</li>
              <li>유료서비스의 요금 및 결제방법은 서비스 화면에 명시된 바에 따릅니다.</li>
              <li>회원이 유료서비스를 이용하는 경우, 회원은 회사가 제공하는 결제수단을 통해 요금을 지불해야 합니다.</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제9조 (회사의 의무)</h2>
            <ol>
              <li>회사는 관련 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다하여 노력합니다.</li>
              <li>회사는 회원의 개인정보 보호를 위해 보안시스템을 구축하며 개인정보처리방침을 공시하고 준수합니다.</li>
              <li>회사는 서비스 이용과 관련하여 회원으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우 이를 처리하여야 합니다.</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제10조 (회원의 의무)</h2>
            <ol>
              <li>회원은 다음 각 호의 행위를 하여서는 안 됩니다:
                <ul>
                  <li>신청 또는 변경 시 허위내용의 등록</li>
                  <li>타인의 정보 도용</li>
                  <li>회사가 게시한 정보의 변경</li>
                  <li>회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
                  <li>회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
                  <li>회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
                  <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위</li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제11조 (저작권의 귀속 및 이용제한)</h2>
            <ol>
              <li>회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다.</li>
              <li>이용자는 서비스를 이용함으로써 얻은 정보 중 회사에게 지적재산권이 귀속된 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>제12조 (분쟁해결)</h2>
            <ol>
              <li>회사는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.</li>
              <li>서비스 이용과 관련하여 회사와 이용자 사이에 분쟁이 발생한 경우, 쌍방 간에 분쟁의 해결을 위하여 성실히 협의합니다.</li>
              <li>본 약관과 관련하여 분쟁이 발생한 경우 관할법원은 민사소송법에 따른 법원으로 합니다.</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>부칙</h2>
            <p>본 약관은 2024년 12월 24일부터 적용됩니다.</p>
          </section>
        </div>
      </main>

      <footer className="legal-footer">
        <p>&copy; 2024 EduStaff. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Terms;
